import { ApiErrorMessageWithTrans } from '@components/Error/ApiErrorMessageWithTrans';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { NoddiCircularLoaderWithTrans } from '@components/Loading/NoddiCircularLoaderWithTrans';
import { type UserSessionData, useAuthContext } from 'noddi-web';
import type { ReactNode } from 'react';
import { useCustomerGroupRole } from '../../hooks/useCustomerGroupRole';
import { HomePageHeader } from './components/HomePageHeader';
import { OrganizationHomePage } from './variants/OrganizationHomePage';
import { OrganizationMemberHomePage } from './variants/OrganizationMemberHomePage';
import { PersonalHomePage } from './variants/PersonalHomePage';

export const Home = () => {
  const { currentUserGroupId: userGroupId, userData, hasTireHotel } = useAuthContext();
  const role = useCustomerGroupRole();

  if (!userGroupId || !userData) {
    return null;
  }

  switch (role.kind) {
    case 'personal':
      return <PersonalHomePage userGroupId={userGroupId} userData={userData} hasTireHotel={!!hasTireHotel} />;
    case 'organizationAdmin':
      return <OrganizationHomePage key={userGroupId} userGroupId={userGroupId} userData={userData} />;
    case 'organizationMember':
      return <OrganizationMemberHomePage key={userGroupId} userGroupId={userGroupId} userData={userData} />;
    case 'loading':
      return (
        <OrganizationRolePendingPage userData={userData}>
          <NoddiCircularLoaderWithTrans />
        </OrganizationRolePendingPage>
      );
    case 'error':
      return (
        <OrganizationRolePendingPage userData={userData}>
          <ApiErrorMessageWithTrans error={role.error} />
        </OrganizationRolePendingPage>
      );
  }
};

/** Keeps the header, with its profile switch and Book button, while the organization role is unknown. */
const OrganizationRolePendingPage = ({ userData, children }: { userData: UserSessionData; children: ReactNode }) => (
  <ContentWrapperCustomerApp hideBackButton width='lg'>
    <div className='flex flex-col gap-6 md:gap-10'>
      <HomePageHeader userData={userData} isFirstTimeCustomer={false} />
      {children}
    </div>
  </ContentWrapperCustomerApp>
);
